export enum CustomerGroupId {
  RETURNING_CUSTOMERS = 14,
  NEW_CUSTOMERS = 15
}

export const getRepeatPropertyFromCustomerGroupId = (customerGroupId: CustomerGroupId | number): boolean =>
  customerGroupId === CustomerGroupId.RETURNING_CUSTOMERS;
